import { Crypto } from '@libs/utilities/crypto';
import { XMLBuilder } from 'fast-xml-parser';

import { ListingLimitationsServiceOld } from './contracts/listing-limitations.service';
import { IPodDesign } from './contracts/pod-design.interface';
import { MbaListingLegacyConverter } from './mba-listing-legacy.converter';
import { DisplateExportService } from './xml/displate-export.service';
import { GlobalExportService } from './xml/global-export.service';
import { MbaExportService } from './xml/mba-export.service';
import { PodExportService } from './xml/pod-export.service';


const XML_KEY_PARTS: string[] = ['U', '9', 'g', 'u', 'i', 'i', '0', 'r', 'A', 'N', 'h', 'N', 'q', 'Q', 's', 'f', '6', '5', 'U', 'o', 'o', 'z', '5', 'j', 'D', 'X', 'u', 'L', 'D', 'H', 'Z', '4'];
/** Legacy desktop uploader format; shared with the browser's XML exporter. */
export function encryptUploadXml(data: object): string {
	const xml = new XMLBuilder({ ignoreAttributes: false }).build(data);
	return Crypto.SymmetricEncryption.encryptAes256(xml, XML_KEY_PARTS.join(''));
}
export function preparePodUploadXml(input: IPodDesign): string {
	const design: IPodDesign = JSON.parse(JSON.stringify(input));
	new MbaListingLegacyConverter().convertListing(design.listing);
	new ListingLimitationsServiceOld().applyPodLimitations(design.listing);
	const exporter = new PodExportService(new GlobalExportService(), new MbaExportService(), new DisplateExportService());
	return encryptUploadXml(exporter.getFormattedPodData(design));
}
